import React from 'react';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash/fp';
import { modeSelectors } from 'selectors/pathBuilder';

const getCertificationHeading = (isPublished, hasDraft, features) => {
  if (isPublished) {
    return t(
      'certifications.certification_builder.header_edit_published_certification',
    );
  }

  if (hasDraft) {
    return t(
      'certifications.certification_builder.header_edit_draft_certification',
    );
  }

  return t(
    'certifications.certification_builder.header_create_new_certification',
  );
};

const getPathHeading = (isPublished, hasDraft) => {
  if (isPublished) {
    return t('paths.path_builder.header.edit_published');
  }

  if (hasDraft) {
    return t('paths.path_builder.header.edit_draft');
  }

  return t('paths.path_builder.header.create_new');
};

const PathHeading = ({
  isPublished,
  hasDraft,
  isCertification,
  editingMode,
  title,
  features,
}) => {
  const getHeading = () => {
    if (!editingMode) {
      return title;
    }

    if (isCertification) {
      return getCertificationHeading(isPublished, hasDraft, features);
    }

    return getPathHeading(isPublished, hasDraft);
  };

  return <h1 className="PathBuilder-title ws-pr">{getHeading()}</h1>;
};

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  isPublished: !!get('publishedAt.date')(pathBuilder),
  hasDraft: !isEmpty(pathBuilder.lastRevision),
  isCertification: !!get('certification')(pathBuilder),
  title: pathBuilder.title,
  editingMode: modeSelectors.isEdit(pathBuilder),
});

export default connect(mapStateToProps)(PathHeading);
